export function removeNonNumericCharacters(text: string): string {
  if (text == null) return '';
  return text.replace(/\D/g, '');
}

export function numberWithCommas(number: number): string {
  let parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export function formatPhoneNumber(phoneNumber: string): string {
  if (phoneNumber == null) return '';
  const digits = phoneNumber.replace(/-/g, '');
  let areaCode = digits.substring(0, 3);
  let prefix = digits.substring(3, 6);
  let lineNumber = digits.substring(6, 10);
  let countryCode = '';
  if (digits.length === 11) {
    countryCode = digits.substring(0, 1);
    areaCode = digits.substring(1, 4);
    prefix = digits.substring(4, 7);
    lineNumber = digits.substring(7, 11);
  }
  if (!prefix) {
    return areaCode;
  }
  if (!lineNumber) {
    return `${areaCode}-${prefix}`;
  }
  if (!countryCode) {
    return `${areaCode}-${prefix}-${lineNumber}`;
  }
  return `${countryCode}-${areaCode}-${prefix}-${lineNumber}`;
}

export const positionPhoneNumber = (
  input: string,
  previousLength: number,
  currentPosition: number,
) => {
  let position = currentPosition;

  if (
    input.length > previousLength &&
    (input.length === 11 || position === 4 || position === 8 || position === 13)
  ) {
    position += 1;
  } else if (
    input.length < previousLength &&
    (previousLength === 11 ||
      position === 4 ||
      position === 8 ||
      position === 13) &&
    input.length > 3 &&
    position > 0
  ) {
    position -= 1;
  }

  return position;
};
